import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTipoSemilla } from "../../../actions/cultivos";
import { useEffect } from "react";
import { useState } from "react";

export const VariedadInput = ({ variedad, handleInputChange }) => {
	const { claveCultivo, variedades } = useSelector((state) => state.altaPermisos);
	const dispatch = useDispatch();

	const [checkTipo, setCheckTipo] = useState("");

	const handleSetTipoSemilla = ({ target }) => {
		setCheckTipo(target.name);
		dispatch(setTipoSemilla(target.name));
	};

	const handleSetVariedad = (e) => {
		const variedad = variedades.find((element) => element === e.target.value);
		const payload = {
			target: {
				name: "variedad",
				type: "text",
				value: variedad,
			},
		};

		handleInputChange(payload);
		// dispatch(setTipoSemilla(variedad));
		// if (claveCultivo === 3 || claveCultivo === 80) handleInputChange(payload);
	};

	useEffect(() => {
		if (claveCultivo === null && variedad !== "") {
			const payload = {
				target: {
					name: "variedad",
					type: "text",
					value: "",
				},
			};
			handleInputChange(payload);
		}
	}, [claveCultivo, handleInputChange, variedad]);

	return (
		<>
			{variedades && variedades.length > 0 ? (
				<div className="col-sm-6">
					<div className="form-group d-flex align-items-baseline row p-3">
						<label className="col-sm-3">
							<span className="text-warning">* </span> Variedad:
						</label>

						<div className="flex-grow-1">
							<select
								className="form-control"
								tabIndex="5"
								name="variedad"
								value={variedad}
								onChange={handleSetVariedad}
								list="variedad"
								disabled={!claveCultivo}
							>
								<option hidden defaultValue="">
									Variedad
								</option>

								{variedades.map((variedad) => (
									<option key={variedad} value={variedad}>
										{variedad}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
			) : (
				<div className="col-sm-6">
					<div className="form-group d-flex align-items-baseline row p-3">
						<label className="col-sm-3">
							<span className="text-warning">* </span> Variedad:
						</label>

						<div className="flex-grow-1">
							<input
								id="variedadInput"
								tabIndex="6"
								type="text"
								className="form-control"
								placeholder="variedad"
								name="variedad"
								value={variedad}
								autoComplete="off"
								onChange={handleInputChange}
								disabled={!claveCultivo}
							/>
						</div>
					</div>
				</div>
			)}

			{claveCultivo === 3 && (
				<div className="col-sm-6">
					<div className="form-group d-flex align-items-baseline row p-3">
						<label className="col-sm-3">
							<span className="text-warning">* </span>
							Tipo:{" "}
						</label>
						<div className="col-sm-3">
							<input
								type="radio"
								id="variedadTrigo"
								name="panificable"
								onChange={handleSetTipoSemilla}
								checked={checkTipo === "panificable"}
								value={checkTipo}
							/>{" "}
							<label htmlFor="panificable"> Panificable </label>
						</div>
						<div className="col-sm-3">
							<input
								type="radio"
								id="variedadTrigo"
								name="cristalino"
								onChange={handleSetTipoSemilla}
								checked={checkTipo === "cristalino"}
								value={checkTipo}
							/>{" "}
							<label htmlFor="cristalino"> Cristalino </label>
						</div>
						<div className="col-sm-3">
							<input
								type="radio"
								id="variedadTrigo"
								name="semilla"
								onChange={handleSetTipoSemilla}
								checked={checkTipo === "semilla"}
								value={checkTipo}
							/>{" "}
							<label htmlFor="semilla"> Semilla </label>
						</div>
					</div>
				</div>
			)}

			{claveCultivo === 80 && (
				<div className="col-sm-6">
					<div className="form-group d-flex align-items-baseline row p-3">
						<label className="col-sm-3">
							<span className="text-warning">* </span>
							Tipo:{" "}
						</label>
						<div className="col-sm-3">
							<input
								type="radio"
								id="variedadAlgodon"
								name="transgenico"
								onChange={handleSetTipoSemilla}
								checked={checkTipo === "transgenico"}
								value={checkTipo}
							/>{" "}
							<label htmlFor="transgenico"> Transgénico </label>
						</div>
						<div className="col-sm-3">
							<input
								type="radio"
								id="variedadAlgodon"
								name="convencional"
								onChange={handleSetTipoSemilla}
								checked={checkTipo === "convencional"}
								value={checkTipo}
							/>{" "}
							<label htmlFor="convencional"> Convencional </label>
						</div>
					</div>
				</div>
			)}
		</>
	);

	// return (
	// 	<>
	// 		<div className="col-sm-6">
	// 			<div className="form-group d-flex align-items-baseline row p-3">
	// 				<label className="col-sm-3">
	// 					<span className="text-warning">* </span>
	// 					Variedad:
	// 				</label>
	// 				<div className="flex-grow-1 ">
	// 					<input
	// 						id="variedadInput"
	// 						tabIndex="6"
	// 						type="text"
	// 						className="form-control"
	// 						placeholder="variedad"
	// 						name="variedad"
	// 						value={variedad}
	// 						autoComplete="off"
	// 						onChange={handleInputChange}
	// 					/>
	// 				</div>
	// 			</div>
	// 		</div>

	// 		{claveCultivo === 3 && (
	// 			<div className="col-sm-6">
	// 				<div className="form-group d-flex align-items-baseline row p-3">
	// 					<label className="col-sm-3">
	// 						<span className="text-warning">* </span>
	// 						Tipo:{" "}
	// 					</label>
	// 					<div className="col-sm-3">
	// 						<input
	// 							type="radio"
	// 							id="variedadTrigo"
	// 							name="panificable"
	// 							onChange={handleSetTipoSemilla}
	// 							checked={checkTipo === "panificable"}
	// 							value={checkTipo}
	// 						/>{" "}
	// 						<label htmlFor="panificable"> Panificable </label>
	// 					</div>
	// 					<div className="col-sm-3">
	// 						<input
	// 							type="radio"
	// 							id="variedadTrigo"
	// 							name="cristalino"
	// 							onChange={handleSetTipoSemilla}
	// 							checked={checkTipo === "cristalino"}
	// 							value={checkTipo}
	// 						/>{" "}
	// 						<label htmlFor="cristalino"> Cristalino </label>
	// 					</div>
	// 					<div className="col-sm-3">
	// 						<input
	// 							type="radio"
	// 							id="variedadTrigo"
	// 							name="semilla"
	// 							onChange={handleSetTipoSemilla}
	// 							checked={checkTipo === "semilla"}
	// 							value={checkTipo}
	// 						/>{" "}
	// 						<label htmlFor="semilla"> Semilla </label>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		)}

	// 		{claveCultivo === 80 && (
	// 			<div className="col-sm-6">
	// 				<div className="form-group d-flex align-items-baseline row p-3">
	// 					<label className="col-sm-3">
	// 						<span className="text-warning">* </span>
	// 						Tipo:{" "}
	// 					</label>
	// 					<div className="col-sm-3">
	// 						<input
	// 							type="radio"
	// 							id="variedadAlgodon"
	// 							name="transgenico"
	// 							onChange={handleSetTipoSemilla}
	// 							checked={checkTipo === "transgenico"}
	// 							value={checkTipo}
	// 						/>{" "}
	// 						<label htmlFor="transgenico"> Transgénico </label>
	// 					</div>
	// 					<div className="col-sm-3">
	// 						<input
	// 							type="radio"
	// 							id="variedadAlgodon"
	// 							name="convencional"
	// 							onChange={handleSetTipoSemilla}
	// 							checked={checkTipo === "convencional"}
	// 							value={checkTipo}
	// 						/>{" "}
	// 						<label htmlFor="convencional"> Convencional </label>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		)}
	// 	</>
	// );
};
